'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'landCategory', 'StatusService', 'LandCategoryService',
    function ($scope, $modalInstance, landCategory, StatusService, LandCategoryService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.landCategory = angular.copy(landCategory);

            if (landCategory == null || angular.equals({}, landCategory) || landCategory.id == null) {
                $scope.title = "Создание новой категории земельного участка";
            } else {
                $scope.title = "Редактирование категории земельного участка \"" + $scope.landCategory.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.landCategory.status) {
                    $scope.landCategory.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.landCategory);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                LandCategoryService.api.isUniqueName({name: name}, {id: $scope.landCategory.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];